<template>
  <section class="container p-4">
    <div class="custom-sidenav shadow" :style="active ? 'display: block;' : 'display: none;'">
      <div class="row">
        <div class="col-12 pt-2 text-right">
          <a href="" @click.prevent="active = false">
            <i class="fal fa-times fa-2x text-secondary"></i>
          </a>
        </div>
        <div class="col-12">
          <main-menu></main-menu>
        </div>
      </div>
    </div>
    <div class="pb-3" v-if="$mq.phone">
      <button class="btn btn-outline-info" @click="active = true">
        <i class="fal fa-bars"></i> {{ $t('message.button.sub_menu') }}
      </button>
    </div>
    <div class="row">
      <div class="col-md-3 sidenav-column">
        <main-menu v-if="!$mq.phone"></main-menu>
      </div>
      <div class="col-md-9 col-12 content-column">
        <router-view/>
      </div>
    </div>
  </section>
</template>

<script>
  import MainMenu from './MainMenu'

  export default {
    components: {
      MainMenu
    },
    data () {
      return {
        active: false
      }
    },
    watch: {
      $route (to, from) {
        this.active = false
      }
    }
  }
</script>

<style scoped>
  .custom-sidenav {
    display: none;
    height: 100%; /* 100% Full-height */
    width: 60%; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1; /* Stay on top */
    top: 0; /* Stay at the top */
    left: 0;
    background-color: #ECEFF1; /* Black*/
    overflow-x: hidden; /* Disable horizontal scroll */
    transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
  }

  .active-side-menu {
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/components/user/Index.vue